import React from 'react';
import { Lead } from '../../types/lead.types';
import { SchoolSegment } from '../../types/project.types';
import LeadCard from './LeadCard';

interface LeadGridProps {
  leads: Lead[];
  onLeadSelect: (lead: Lead) => void;
  validationDeadlineDays?: number;
  segments?: SchoolSegment[];
}

const LeadGrid: React.FC<LeadGridProps> = ({ leads, onLeadSelect, validationDeadlineDays, segments }) => {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {leads.map((lead) => (
        <LeadCard
          key={lead.id}
          lead={lead}
          onClick={() => onLeadSelect(lead)}
          validationDeadlineDays={validationDeadlineDays}
          segments={segments}
        />
      ))}
    </div>
  );
};

export default LeadGrid;
